export default __webpack_public_path__ + "static/media/25.a0a35927.jpg";